import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from '@mui/icons-material/Visibility';
import DescriptionIcon from '@mui/icons-material/Description';
import AssessmentIcon from '@mui/icons-material/Assessment';
import PrintIcon from '@mui/icons-material/Print';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'; // Added for View icon

import { ViewSummaryTab } from "./tabs/ViewSummaryTab";
import { ViewResultsTab } from "./tabs/ViewResultsTab";
import { PDFModal as PDFViewModal } from "../../../../common/Modal"; // Import your existing PDF Viewer
import axios from '../../../../api/apiClient';
import { token, domain } from '../../../Security';
import { generateAppraisalPdf } from "./services/AppraisalPdfService";

export function PerformanceAppraisalViewModal({ isOpen, onClose, data }) {
  const [activeTab, setActiveTab] = useState("summary");
  const [legendDefinitions, setLegendDefinitions] = useState([]);
  
  // PDF Preview States
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [pdfFileUrl, setPdfFileUrl] = useState(null);

  useEffect(() => {
    if (!isOpen) {
      setActiveTab("summary");
      setLegendDefinitions([]);
    } else if (data?.performanceRatingsLegendId) {
      axios.get(`${domain}/api/PerformanceRatingLegendGroup/active`, {
        headers: { 'Authorization': `Bearer ${token}` }
      }).then(res => {
        const currentLegend = res.data.find(l => l.id === data.performanceRatingsLegendId);
        setLegendDefinitions(currentLegend?.performanceRatingDefinitions || []);
      });
    }
  }, [isOpen, data]);

  const handlePreviewPDF = () => {
    const url = generateAppraisalPdf(data, "preview");
    console.log({data})
    setPdfFileUrl(url);
    setShowPdfModal(true);
  };

  const handleDownloadPDF = () => {
    generateAppraisalPdf(data, "download");
  };

  if (!isOpen || !data) return null;

  return (
    <>
      <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 p-3">
        <div className="relative flex h-auto max-h-[95vh] w-full max-w-6xl flex-col rounded-lg bg-gray-50 shadow-xl">
          
          {/* Header */}
          <div className="sticky top-0 z-10 flex items-center justify-between rounded-t-lg border-b border-gray-200 bg-white px-6 py-2 shadow-sm">
            <h2 className="flex items-center space-x-2 text-xl font-semibold text-gray-800">
              <VisibilityIcon className="text-sky-600" />
              <span className="text-xl text-gray-600 tracking-tight">
                Appraisal Report Viewer
              </span>
            </h2>
            <button onClick={onClose} className="border-none bg-transparent p-1 text-gray-400 hover:text-gray-700 cursor-pointer">
              <CloseIcon fontSize="medium" />
            </button>
          </div>

          {/* Tab Navigation */}
          <div className="border-b border-gray-200 bg-white pt-3 px-6 flex space-x-1">
            <button
              onClick={() => setActiveTab("summary")}
              className={`px-4 py-3 text-sm font-medium rounded-t-lg transition-colors border-b-2 ${
                activeTab === "summary" ? "border-blue-500 text-blue-600 bg-blue-50" : "border-transparent text-gray-500 hover:bg-gray-50"
              }`}
            >
              <DescriptionIcon fontSize="small" className="mr-2" /> Summary
            </button>
            <button
              onClick={() => setActiveTab("results")}
              className={`px-4 py-3 text-sm font-medium rounded-t-lg transition-colors border-b-2 ${
                activeTab === "results" ? "border-blue-500 text-blue-600 bg-blue-50" : "border-transparent text-gray-500 hover:bg-gray-50"
              }`}
            >
              <AssessmentIcon fontSize="small" className="mr-2" /> Evaluation
            </button>
          </div>

          {/* Tab Content */}
          <div className="flex-1 overflow-y-auto p-6 bg-white/50">
            {activeTab === "summary" ? (
              <ViewSummaryTab data={data} legendDefinitions={legendDefinitions} />
            ) : (
              <ViewResultsTab data={data} legendDefinitions={legendDefinitions} />
            )}
          </div>

          {/* Footer - Updated with View and Download buttons */}
          <div className="flex justify-between items-center border-t border-gray-200 bg-white p-5 rounded-b-lg">
            <div className="flex space-x-2">
              {/* Preview Button */}
              <button
                onClick={handlePreviewPDF}
                className="flex items-center space-x-2 bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg font-bold transition-all border-none cursor-pointer shadow-sm"
              >
                <PictureAsPdfIcon fontSize="small" />
                <span>View PDF</span>
              </button>

              {/* Download Button */}
              <button
                onClick={handleDownloadPDF}
                className="flex items-center space-x-2 bg-sky-600 hover:bg-sky-700 text-white px-4 py-2 rounded-lg font-bold transition-all border-none cursor-pointer shadow-sm"
              >
                <PrintIcon fontSize="small" />
                <span>Download PDF</span>
              </button>
            </div>

            <button
              onClick={onClose}
              className="bg-gray-400 hover:bg-gray-500 text-white px-6 py-2 rounded-lg font-bold transition-all border-none cursor-pointer"
            >
              Close
            </button>
          </div>
        </div>
      </div>

      {/* Reusable PDF Viewer Modal */}
      <PDFViewModal
        visible={showPdfModal}
        fileUrl={pdfFileUrl}
        onClose={() => {
          setShowPdfModal(false);
          setPdfFileUrl(null);
        }}
      />
    </>
  );
}